import Home from './Home';
import Page from './Page';
import Productions from './Productions';
import News from './News';
import Contact from './Contact';
import Post from './Post';
import Production from './Production';

const PagesComponents = {
    Home,
    Page,
    Productions,
    News,
    Contact,
    Post,
    Production,
};

export default PagesComponents;



// WEBPACK FOOTER //
// ./js/components/pages/index.js